import { combineReducers } from "redux";
import headlinesReducer from "./headlines";
import descriptionsReducer from "./descriptions";
import businessNameReducer from "./businessName";
import imagesReducer from "./images";
import croppedImagesReducer from "./croppedImages";
import croppedLogosReducer from "./croppedLogos";
import previewReducer from "./preview";
import loadingReducer from "./loading";

/**
 * TODO: one reducer for headlines and descriptions
 */
export default combineReducers({
  headlines: headlinesReducer,
  descriptions: descriptionsReducer,
  images: imagesReducer,
  croppedImages: croppedImagesReducer,
  croppedLogos: croppedLogosReducer,
  businessName: businessNameReducer,
  previewImages: previewReducer,
  loadingInfo: loadingReducer
});
